import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getEstateComparisonReportData
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllActiveGroups', null)
    for (let item of Object.entries(response.data)) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
    return groupArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return estateArray;
}


async function getEstateComparisonReportData(data) {
    var model = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        fromDate: data.fromDate,
        toDate: data.toDate,
    };
    const response = await CommonPost('/api/EstateComparisonReport/GetEstateComparisonReportData', null, model);
    return response.data;
}
